import { createSlice } from '@reduxjs/toolkit'
import axios from 'axios'


export const sesionSlice = createSlice({
    name: 'sesion',
    initialState: {
        estudiante: { sesion: [] }
    },
    reducers: {
        setSesion: (state, action) => {
            state.estudiante = action.payload
        }
    }
})


export const { setSesion } = sesionSlice.actions

export default sesionSlice.reducer


export const getSesion = (accounts) => async (dispatch) => {

    const mail = accounts[0].username

    try {

        return await axios
            .post(
                `${process.env.REACT_APP_API_URL}/v1_ufe/ufe_sesionTNE`, { mail: mail },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': process.env.REACT_APP_TOKEN
                    }
                }
            )
            .then(response => {
                console.log('dispatch session', response.data)
                dispatch(setSesion(response.data))
            })

    } catch (error) {

        console.log('dispatch error', error)

    }

}
